module.exports = __webpack_public_path__ + "static/media/list_4.3797400e.svg";